module.exports = __webpack_public_path__ + "img/zwcx.ba9964f6.png";